<template>
  <v-card max-width="800" flat class="pa-1 mx-auto ma-1 rounded-xl">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'ContainerFlat'
}
</script>

<style scoped>

</style>
